import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface PauseIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const PauseIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: PauseIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <g clipPath="url(#clip0_1_5821)">
                <path
                    d="M18 6.5C18 5.67157 17.3284 5 16.5 5C15.6716 5 15 5.67157 15 6.5V17.5C15 18.3284 15.6716 19 16.5 19C17.3284 19 18 18.3284 18 17.5V6.5Z"
                    stroke={color}
                    strokeWidth={2}
                    strokeLinecap="round"
                />
                <path
                    d="M9 6.5C9 5.67157 8.32843 5 7.5 5C6.67157 5 6 5.67157 6 6.5V17.5C6 18.3284 6.67157 19 7.5 19C8.32843 19 9 18.3284 9 17.5V6.5Z"
                    stroke={color}
                    strokeWidth={2}
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_5821">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default PauseIcon
